import React, { useState } from 'react';
import PropTypes from 'prop-types';

import parse from 'html-react-parser';
import ReqInput from '../../common/ReqInput/index';
import EmailInput from '../../common/EmailInput/index';
import { normalizePhoneNumber } from '../../common/validation';
import VdsRadioButton from '../../common/RadioButton';
import { Micro, Body } from '../../common/Typography';
import { isMobile } from '../../common/Helpers';
import VdsTooltip from '../../common/Tooltip';
import Notification from '../../common/Notification/index';

const AppointmentReminder = (props) => {
  const [selectedType, setSelectedType] = useState(props.reminderType || 'Call');
  const {
    isReminderChoosen,
    reminderType,
    contactEditProps,
    isEmailSuccess,
    accMainEmailVal,
    emailBannerTitle,
    emailBannerSubtitle,
    emailBannerConfirmText,
    emailConfirm,
    onSuccess,
  } = props;

  const handleRadioButtonClick = (type) => {
    setSelectedType(type);
    props.handleReminder(type);
  };
  
  return (
    <div className="appointRemContainer">
      {!isReminderChoosen && (
        <div className="marginTop16 marginBottom30">
          <VdsRadioButton
            defaultValue={reminderType || 'Call'}
            onChange={(e) => {
              handleRadioButtonClick(e.target.value);
            }}
            error={false}
            data={[
              {
                name: 'appointmentSlot',
                children: 'Call me',
                value: 'Call',
                ariaLabel: 'Call me',
              },
              {
                name: 'appointmentSlot',
                children: (
                  <React.Fragment>
                    <Body size="large" bold={false}>
                      Text me
                    </Body>
                    <Body size="large" bold={false} color="#6F7171">
                      No Charge
                    </Body>
                  </React.Fragment>
                ),
                value: 'SMS',
                ariaLabel: 'Text me',
              },
              {
                name: 'appointmentSlot',
                children: 'Email me',
                value: 'Email',
                ariaLabel: 'email',
              },
            ]}
          />
        </div>
      )}
      {selectedType === 'Email' ? (
        <div>
          <div>
            <EmailInput
              defaultValue={props.defaultEmail}
              value={props.email}
              id="appointmentVdsEmail"
              name="emailId"
              type="text"
              placeholder=""
              ariaLabel="Email Address Required Input Fields"
              required
              success={
                props.isValidEmail &&
                (isEmailSuccess?.valid === 'Valid' || isEmailSuccess?.valid === 'White_listed' || isEmailSuccess?.valid === 'true') &&
                !props.emailMaxAttempts
              }
              label="Email Address"
              helperText={props.appointment_email_legal}
              helperTextPlacement="bottom"
              onChange={(e) => props.onEmailChange(e)}
              data-cs-mask
              error={!!(props.emailError && props.emailError !== '')}
              errorText={props.emailError}
              emailAPICall={!props.emailMaxAttempts ? props.emailAPICall : null}
              isValidEmail={props.isValidEmail}
              contactEmailCTA={props.contactEmailCTA}
              pageName="appointment"
              existEmail={props.existEmail}
              setEmailValidationdata={props.setEmailValidationdata}
              hideBlurFlag
            />
          </div>
          {props.manualValidation &&
            isMobile() &&
            !accMainEmailVal?.success &&
            contactEditProps.contact_info_manual_email_validation_text_mobile &&
            !props.emailError && (
              <div>
                <Micro primitive="span">{parse(contactEditProps.contact_info_manual_email_validation_text_mobile)}</Micro>
                <div className="displayInlineFlex">
                  <VdsTooltip id="emailValTooltip" direction="top" role="tooltip" tabIndex="0" size="small">
                    <span>{contactEditProps.contact_info_email_validation_tooltip_text}</span>
                  </VdsTooltip>
                </div>
              </div>
            )}
          {props.manualValidation &&
            !isMobile() &&
            !accMainEmailVal?.success &&
            contactEditProps.contact_info_manual_email_validation_text_desktop &&
            !props.emailErrorText && (
              <div>
                <Micro primitive="span">{parse(contactEditProps.contact_info_manual_email_validation_text_desktop)}</Micro>
                <div className="displayInlineFlex">
                  <VdsTooltip id="emailValTooltip" direction="top" role="tooltip" tabIndex="0" size="small">
                    <span>{contactEditProps.contact_info_email_validation_tooltip_text}</span>
                  </VdsTooltip>
                </div>
              </div>
            )}
          {props.manualValidation && props.emailError && accMainEmailVal?.success && (
            <Notification
              type="info"
              title={emailBannerTitle}
              subtitle={parse(`${emailBannerSubtitle}<br>${emailBannerConfirmText}`)}
              hideCloseButton
              className="marginTop15"
              layout="vertical"
              buttonData={[
                {
                  children: 'Confirm',
                  onClick: (event) => emailConfirm(event, 'appointmentVdsEmail'),
                  'data-track': '{"type":"link","name":"email-validation-confirm"}',
                },
              ]}
            />
          )}
        </div>
      ) : (
        <ReqInput
          defaultValue={normalizePhoneNumber(props.phoneNumber)}
          value={normalizePhoneNumber(props.phoneNumber)}
          id="phoneNumber"
          type="tel"
          placeholder=""
          className="contactInput36"
          label="Mobile Phone Number"
          success= {onSuccess}
          required
          error={!!(props.phoneError && props.phoneError !== '')}
          errorText={props.phoneError}
          onChange={(e) => props.onPhoneNumberChange(e)}
          width={isMobile() ? '100%' : '398px'}
        />
      )}
    </div>
  );
};

AppointmentReminder.propTypes = {
  handleReminder: PropTypes.func,
  onPhoneNumberChange: PropTypes.func,
  onEmailChange: PropTypes.func,
  phoneError: PropTypes.string,
  reminderType: PropTypes.string,
  isReminderChoosen: PropTypes.bool,
  phoneNumber: PropTypes.string,
  emailError: PropTypes.string,
  isEmailSuccess: PropTypes.string,
  emailMaxAttempts: PropTypes.string,
  accMainEmailVal: PropTypes.object,
  contactEditProps: PropTypes.object,
  emailAPICall: PropTypes.func,
  contactEmailCTA: PropTypes.string,
  email: PropTypes.string,
  manualValidation: PropTypes.string,
  emailErrorText: PropTypes.string,
  defaultEmail: PropTypes.string,
  emailBannerTitle: PropTypes.string,
  emailBannerSubtitle: PropTypes.string,
  emailBannerConfirmText: PropTypes.string,
  emailConfirm: PropTypes.string,
  setEmailValidationdata: PropTypes.func,
  existEmail: PropTypes.func,
  appointment_email_legal: PropTypes.string,
  isValidEmail: PropTypes.bool,
  onSuccess: PropTypes.bool,
};

export default AppointmentReminder;
/** **
 *
 *
 *   // radioButtonChange = (event) => {
  //   // alert(event.target.value);
  //   const selectedValue = event.target.value;
  //   if (selectedValue === 'email') {
  //     props.handleReminder('Email');
  //     this.setState({ email: true, call: false, text: false });
  //   }
  //   if (selectedValue === 'text') {
  //     props.handleReminder('SMS');
  //     this.setState({ email: false, call: false, text: true });
  //   }
  //   if (selectedValue === 'call') {
  //     props.handleReminder('Call');
  //     this.setState({ email: false, call: true, text: false });
  //   }
  // }
<Row>
            <Col
              xs={4}
              lg={4}
              md={4}
              analyticstrack="5G-appointmentReminderType-call"
              style={{ paddingLeft: '8px' }}
              className="fontSizeSmall"
            >
  <RadioButton
  id="callMeBtn"
  aria-label="Call me"
  analyticstrack="5g-installation-Call me"
  data-track={'{"type" : "input", "name" : "5g-installation-Call me", "state" :"$stateVari"}'.replace(
    '$stateVari',
    selectedCallRadioButton ? 'checked' : 'Unchecked',
  )}
  value="Call me"
  checked={selectedCallRadioButton}
  onChange={() => {
    document.querySelector('#callMeBtn').setAttribute('aria-selected', true);
    document.querySelector('#textMeBtn').setAttribute('aria-selected', false);
    document.querySelector('#emailMeBtn').setAttribute('aria-selected', false);
    // this.setState({
    //   selectedCallRadioButton: true,
    //   selectedTextRadioButton: false,
    //   selectedEmailRadioButton: false,
    // });
    handleRadioButtonClick(true, false, false);
    props.handleReminder('Call');
  }}
  onKeyPress={() => {
    props.handleReminder('Call');
    // this.setState({
    //   selectedCallRadioButton: true,
    //   selectedTextRadioButton: false,
    //   selectedEmailRadioButton: false,
    // });
    handleRadioButtonClick(true, false, false);
  }}
>
  Call me
</RadioButton>
</Col>
<Col
xs={4}
lg={4}
md={4}
analyticstrack="5G-appointmentReminderType-text"
className="fontSizeSmall"
>
<RadioButton
  name="appointmentSlot"
  containerClassName="margin10 noSideMargin appointmentSlot"
  labelClassName="displayInlineBlock onlyLeftPad pad6 verticalTop radioLabel"
  id="textMeBtn"
  analyticstrack="5g-installation-Text me"
  data-track={'{"type" : "input", "name" : "5g-installation-Text me", "state" :"$stateVari"}'.replace(
    '$stateVari',
    selectedTextRadioButton ? 'checked' : 'Unchecked',
  )}
  aria-label="Text me"
  value="Text me"
  checked={selectedTextRadioButton}
  onChange={() => {
    document.querySelector('#textMeBtn').setAttribute('aria-selected', true);
    document.querySelector('#callMeBtn').setAttribute('aria-selected', false);
    document.querySelector('#emailMeBtn').setAttribute('aria-selected', false);
    handleRadioButtonClick(false, true, false);
    props.handleReminder('SMS');
  }}
  onKeyPress={() => {
    handleRadioButtonClick(false, true, false);
    props.handleReminder('SMS');
  }}
>
  <span>
    Text me
    <br /> *No Charge
  </span>
</RadioButton>
</Col>
<Col
xs={4}
lg={4}
md={4}
analyticstrack="5G-appointmentReminderType-email"
className="fontSizeSmall"
>
<RadioButton
  name="appointmentSlot"
  containerClassName="margin10 noSideMargin appointmentSlot"
  labelClassName="displayInlineBlock onlyLeftPad pad6 verticalCenter radioLabel"
  id="emailMeBtn"
  analyticstrack="5g-installation-Email me"
  data-track={'{"type" : "input", "name" : "5g-installation-Email me", "state" :"$stateVari"}'.replace(
    '$stateVari',
    selectedEmailRadioButton ? 'checked' : 'Unchecked',
  )}
  aria-label="email"
  value="email"
  checked={selectedEmailRadioButton}
  onChange={() => {
    document.querySelector('#emailMeBtn').setAttribute('aria-selected', true);
    document.querySelector('#textMeBtn').setAttribute('aria-selected', false);
    document.querySelector('#callMeBtn').setAttribute('aria-selected', false);
    handleRadioButtonClick(false, false, true);
    props.handleReminder('Email');
  }}
  onKeyPress={() => {
    handleRadioButtonClick(false, false, true);
    props.handleReminder('Email');
  }}
>
  Email me
</RadioButton>
</Col>
</Row>


 */
